import gql from 'graphql-tag';

const CREATE_SALESFORCE_OPPORTUNITY = gql`
  mutation CreateSalesforceOpportunity($opportunity: SalesforceOpportunityInput!) {
    createSalesforceOpportunity(opportunity: $opportunity)
  }
`;

export default CREATE_SALESFORCE_OPPORTUNITY;
